import UltMeta, { Meta } from "./UltMeta/index";


class Goods extends UltMeta {
    MECHANISM_SAND_0_5 = new Meta(1, "机制砂0-5mm");
    MELON_RICE_5_16 = new Meta(2, "瓜米5-16mm");
    STONE_16_25 = new Meta(3, "石子16-25mm");
}
export const GOODS = new Goods();

class SpecialZone extends UltMeta {
    CDI_QICHUN = new Meta(1, "中电建蕲春");
}
export const SPECIAL_ZONE = new SpecialZone();

/** 专区预约单状态（与后端枚举值对齐） */
class ReservationOrderState extends UltMeta {
    PENDING_AUDIT = new Meta(1, "未审核");
    AUDITED = new Meta(2, "已审核");
    PENDING_CONFIRM = new Meta(3, "待确认");
    CONFIRMED = new Meta(4, "已提货");
    CANCELLED = new Meta(5, "已取消");
}
export const RESERVATION_ORDER_STATE = new ReservationOrderState();


class State extends UltMeta {
    EFFECTIVE = new Meta(1, "正常");
    CANCELLED = new Meta(2, "已取消");
}
export const STATE = new State();